export default __webpack_public_path__ + "static/media/bmw1.ebc76c3b.jpeg";